/** Platform admin (P9): strings shared by every admin screen and the shared tenant dialogs. */
export const common = {
  maintenanceOn: "Maintenance mode is ON.",
  maintenanceBody: "Tenant consoles are read-only until it is turned off.",
  maintenanceManage: "Manage",
  readOnlyRole: "Read-only for your role",
  loadError: "This page couldn't load.",
  loadErrorBody: "Check your connection and try again. Nothing was changed.",
  sectionError: "This section couldn't load.",
  saving: "Saving…",
  saved: "Changes saved",
  saveChanges: "Save changes",
  reset: "Reset",
  cancel: "Cancel",
  close: "Close",
  done: "Done",
  edit: "Edit",
  remove: "Remove",
  export: "Export",
  exportQueued: "Export queued — you'll get an email when it's ready",
  copyId: "Copy ID",
  copied: "Copied to clipboard",
  viewAll: "View all",
  search: "Search",
  actions: "Actions",
  moreActions: "More actions",
  none: "None",
  unlimited: "Unlimited",
  notSet: "Not set",
  yes: "Yes",
  no: "No",
  enabled: "Enabled",
  disabled: "Disabled",
  perMonth: "/mo",
  perYear: "/yr",
  usdApprox: "≈ {{php}}",
  required: "Required",
  typeToConfirm: "Type {{value}} to confirm",
  confirmMismatch: "That doesn't match.",
  impersonate: {
    action: "Impersonate",
    title: "Impersonate {{tenant}}",
    description: "Open the tenant console as this workspace's Admin. The session is logged and the owner is emailed afterwards.",
    reason: "Reason",
    reasonPlaceholder: "e.g. Customer asked us to check why answers about pricing are wrong",
    reasonHint: "At least 10 characters. Shown in the tenant's audit log.",
    reasonTooShort: "Give a reason of at least 10 characters.",
    ticket: "Ticket #",
    ticketPlaceholder: "e.g. T-1042",
    ticketRequired: "Link a support ticket.",
    readOnly: "Read-only mode",
    readOnlyHint: "Block saves, uploads, deletes and outbound messages.",
    readOnlyForced: "Your role can only impersonate read-only.",
    duration: "Duration",
    minutes: "{{count}} minutes",
    durationHint: "Capped at {{max}} minutes by Platform settings → Security.",
    start: "Start session",
    started: "Impersonation started · console opened in a new tab",
    writeWarning: "Write access enabled — every change is attributed to you",
    popupBlocked: "Your browser blocked the new tab.",
    openConsole: "Open tenant console",
  },
  changePlan: {
    action: "Change plan",
    title: "Change plan · {{tenant}}",
    description: "Pick the plan this workspace moves to. Limits change with the plan.",
    current: "Current",
    custom: "Custom",
    effective: "Effective",
    now: "Immediately (prorate)",
    renewal: "Next billing date",
    submit: "Change plan",
    done: "Plan changed to {{plan}}",
    limits: "{{messages}} messages · {{agents}} agents · {{seats}} seats",
  },
  suspend: {
    action: "Suspend tenant",
    title: "Suspend {{tenant}}?",
    description: "The widget and web app show a maintenance message. Data is kept and the tenant can be reinstated.",
    reason: "Reason",
    reasons: {
      non_payment: "Non-payment (past due > 14 days)",
      abuse: "Abuse / acceptable use violation",
      requested_by_tenant: "Requested by tenant",
      security_incident: "Security incident",
      other: "Other",
    },
    note: "Internal note",
    noteHint: "Visible to CRUD.IT staff only",
    notify: "Email the owner with the reason and reinstatement steps",
    submit: "Suspend tenant",
    done: "Tenant suspended · widget and web app now show a maintenance message",
  },
  reinstate: {
    action: "Reinstate tenant",
    title: "Reinstate {{tenant}}?",
    description: "Agents, widget and web app come back online immediately.",
    submit: "Reinstate",
    done: "Tenant reinstated",
  },
  deleteTenant: {
    action: "Delete tenant",
    title: "Delete {{tenant}}?",
    description: "The workspace is soft-deleted now and permanently purged after 30 days (NPC retention policy). Active subscriptions are cancelled.",
    label: "Type the tenant name to confirm",
    submit: "Delete tenant",
    done: "Deletion scheduled · data purged in 30 days unless restored",
    superAdminOnly: "Only a Super Admin can delete tenants",
  },
} as const;
